export enum CustomerType {
    Private = 'private',
    Professional = 'professional',
    Business = 'business',
    }